import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledPageWrapper = styled(Ds.Flex)`
    width: 100%;
    height: 100%;
    background: var(--ds-color-white);
    padding: 1rem;
`;

export const StyledContent = styled(Ds.Flex)`
    max-width: 100%;
    text-align: center;
    width: 600px;
`;

export const StyledOrganisationName = styled.blockquote`
    word-break: break-word;
    margin: 0;
    padding-left: 1rem;
    border-left: 4px solid var(--ds-color-silver);
    color: var(--ds-color-metal);
`;

export const StyledForm = styled(Ds.Form)`
    padding: 1.5rem;
    border: 1px solid var(--ds-color-dishwater);
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    justify-content: flex-end;
    align-items: stretch;
`;
